// extracted by mini-css-extract-plugin
export default {"wrapper":"CommunicationSkeleton_wrapper__xT4aX","slide":"CommunicationSkeleton_slide__8UbF+"};